import { type FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { renderGeneAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";
import { useURLViewID } from "@/app-utils/hooks/useUrl.ts";
import { type InputTableQuerySpec } from "@/graphql.ts";
import { type IGeneState } from "@/redux/modules/gene.ts";
import { type IAppState } from "@/redux/reducer.ts";
import { DATATABLE_ID_TYPE, ENTITY_TYPE } from "@/settings/settings.js";

import GenericDataTableContainer from "../core/grid/GenericDataTableContainer.js";
import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import { ChildEntitiesButtonHeader } from "../core/navigation-panel/ButtonHeaderHoc.js";

const GeneTranscriptsView: FC = () => {
  const [tableSpec, setTableSpec] = useState<InputTableQuerySpec>();
  const { geneId } = useParams<"geneId">();
  const viewId = useURLViewID();
  const { gene } = useSelector<IAppState, IGeneState>((state) => state.gene);

  useEffect(() => {
    if (geneId) {
      setTableSpec({
        id: geneId,
        idType: DATATABLE_ID_TYPE.ENTITY,
        queryType: ENTITY_TYPE.GENE,
        resultType: ENTITY_TYPE.TRANSCRIPT,
      });
    }
  }, [geneId]);

  return (
    <GenericDataTableContainer
      tableSpec={tableSpec}
      rightToolbarElement={<ChildEntitiesButtonHeader tableSpec={tableSpec} getParentEntityName={() => gene?.name} />}
      viewId={viewId ?? undefined}
      headerAttributes={[
        <AttributesListWidget attributes={renderGeneAttributesWidgets(gene)} key={"gene-transcript-view-widget-1"} />,
      ]}
      title={gene?.name}
      subtitle={gene?.description || "List of Transcripts"}
    />
  );
};

export default GeneTranscriptsView;
